import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import ContentRoutes from 'ContentUtils/Routes';
//@ts-ignore not typed yet
import { noThemeImage } from 'ContentComponents/imgAssets';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themeSettings.universal.dependentsPanel.${key}`;
const ThemeEPDependentsPanel = ({
  children,
  themeName,
  themePath,
  templatePath,
  imageUrl,
  onClose,
  totalDependents,
  lastSave,
  handleOpenRevisionsModal
}) => {
  const lastSaveTimestamp = new Date(lastSave);
  const lastSavedTimeDisplay = I18n.moment.portalTz(lastSaveTimestamp).format('l LT');
  const handleOpenFullThemeEditor = () => {
    const params = {
      redirectUrl: window.location.pathname,
      fromAppName: 'pageEditor',
      templatePath
    };
    window.location = ContentRoutes.themeEditor(themePath, params);
  };
  return /*#__PURE__*/_jsxs(ModalPanel, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('title')
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      padding: "0",
      children: [/*#__PURE__*/_jsx(View, {
        paddingBlock: "800",
        backgroundColor: "fill-surface-recessed",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Image, {
            blockSize: "80px",
            inlineSize: "126px",
            responsive: false,
            objectFit: "cover",
            src: imageUrl || noThemeImage,
            paddingInlineEnd: "400",
            paddingInlineStart: "800"
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              truncate: true,
              paddingInlineEnd: "200",
              paddingBlockEnd: "0",
              children: themeName
            }), /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              paddingBlockStart: "100",
              children: [/*#__PURE__*/_jsxs(Flex, {
                children: [/*#__PURE__*/_jsx(Badge, {
                  use: "oz",
                  children: /*#__PURE__*/_jsx(Text, {
                    as: "code",
                    textTransform: "uppercase",
                    color: "fill-field-default",
                    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                      message: i18nKey('content')
                    })
                  })
                }), /*#__PURE__*/_jsx(Text, {
                  typography: "detail-100",
                  paddingInlineStart: "200",
                  paddingBlockStart: "100",
                  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                    message: i18nKey('hubspot')
                  })
                })]
              }), /*#__PURE__*/_jsx(Flex, {
                paddingBlockStart: "200",
                children: /*#__PURE__*/_jsx(Text, {
                  typography: "detail-100",
                  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                    message: i18nKey('lastSaved'),
                    options: {
                      time: lastSavedTimeDisplay
                    }
                  })
                })
              })]
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs(View, {
        marginInlineStart: "800",
        paddingBlock: "800",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          paddingBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('subTitle'),
            options: {
              count: totalDependents,
              themeName
            }
          })
        }), /*#__PURE__*/_jsx(View, {
          maxInlineSize: "80%",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            paddingInlineEnd: "1200",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: i18nKey('description')
            })
          })
        })]
      }), children]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(View, {
        backgroundColor: "fill-surface-recessed",
        children: [/*#__PURE__*/_jsxs(Button, {
          onClick: handleOpenFullThemeEditor,
          use: "primary",
          marginInlineEnd: "200",
          children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('themeEditorAppLink')
          }), /*#__PURE__*/_jsx(ExternalLinkIcon, {
            size: "300"
          })]
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleOpenRevisionsModal,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('versionHistoryLink')
          })
        })]
      })
    })]
  });
};
export default ThemeEPDependentsPanel;